var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { class: ["box", "is-shadowless"] }, [
    _vm.heading
      ? _c("h3", {
          staticClass: "title is-4 has-text-weight-bold column-title",
          domProps: { textContent: _vm._s(_vm.heading) },
        })
      : _vm._e(),
    _vm.chartData
      ? _c(
          "div",
          { staticClass: "chart" },
          [
            _c(_vm.type + "Chart", {
              tag: "component",
              attrs: {
                "chart-data": _vm.chartData.data,
                options: _vm.options,
                "x-scale-label": _vm.xScaleLabel,
                "y-scale-label": _vm.yScaleLabel,
                "show-tooltip": _vm.showTooltip,
                "prepend-tooltip": _vm.prependtooltip,
              },
            }),
          ],
          1
        )
      : _c(
          "div",
          [
            _vm.isFetching
              ? _c("dc-icon", {
                  attrs: { icon: "sync", "no-margin": "", spin: "" },
                })
              : _vm._e(),
            _c("span", { domProps: { textContent: _vm._s(_vm.label) } }),
          ],
          1
        ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }